'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = modifierKeyReducer;

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _dragModifierKeysConstants = require('./dragModifierKeysConstants');

var _draggingConstants = require('../../../reducers/draggingConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Constants
var initialState = Immutable.fromJS({
    ctrlKey: false,
    shiftKey: false,
    altKey: false,
    metaKey: false
}); // Lib
function modifierKeyReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _dragModifierKeysConstants.DRAG_MODIFIER_KEYS_SET:
            return Immutable.fromJS(action.modifierKeys);
        case _draggingConstants.DRAG_END:
            return initialState;
        default:
            return state;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/dnd/modifierKeys/dragModifierKeysReducer.js
// module id = 2122
// module chunks = 0